export const INCREMENT_COUNT = "INCREMENT_COUNT";
export const DECREMENT_COUNT = "DECREMENT_COUNT";

// Home
export const SET_APPBAR_TITLE = "SET_APPBAR_TITLE";
export const SET_APP_LANGUAGE = "SET_APP_LANGUAGE";
export const CLOSE_DRAWER = "CLOSE_DRAWER";
export const OPEN_DRAWER = "OPEN_DRAWER";
export const TOGGLE_ADMIN_MENU = "TOGGLE_ADMIN_MENU";
export const TOGGLE_DATA_MENU = "TOGGLE_DATA_MENU";
export const TOGGLE_CREATION_MENU = "TOGGLE_CREATION_MENU";
export const TOGGLE_DASHBOARD_MENU = "TOGGLE_DASHBOARD_MENU";
export const TOGGLE_MONITORING_MENU = "TOGGLE_MONITORING_MENU";
export const TOGGLE_DEPLOYMENT_MENU = "TOGGLE_DEPLOYMENT_MENU";
export const TOGGLE_SECURITY_MENU = "TOGGLE_SECURITY_MENU";
export const TOGGLE_URLCALLS_MENU = "TOGGLE_URLCALLS_MENU";
export const TOGGLE_CAROUSEL_MENU = "TOGGLE_CAROUSEL_MENU";
export const TOGGLE_ORGANISATION_MENU = "TOGGLE_ORGANISATION_MENU";
export const TOGGLE_SYS_ADMIN_MENU = "TOGGLE_SYS_ADMIN_MENU";
export const CLOSE_ALL_MENUS = "CLOSE_ALL_MENUS";
export const CHANGE_CURRENT_MENU_NAME = "CHANGE_CURRENT_MENU_NAME";
export const IS_ACTIVE_MINIFY = "IS_ACTIVE_MINIFY";

// Configuration
export const GET_CONFIGURATIONS_COMPLETED = "GET_CONFIGURATIONS_COMPLETED";

// Auth
export const LOGIN_COMPLETED = "LOGIN_COMPLETED";
export const LOGOFF_COMPLETED = "LOGOFF_COMPLETED";

// Administration
export const GET_CURRENTUSER_COMPLETED = "GET_CURRENTUSER_COMPLETED";
export const GET_ORGANIZATION_COMPLETED = "GET_ORGANIZATION_COMPLETED";
export const GET_CURRENTUSER_USERGROUPS_COMPLETED = "GET_CURRENTUSER_USERGROUPS_COMPLETED";
export const GET_CURRENTUSER_ACCESSRIGHTS_COMPLETED = "GET_CURRENTUSER_ACCESSRIGHTS_COMPLETED";
export const SET_CURRENTUSER_NEWSETTINGS = "SET_CURRENTUSER_NEWSETTINGS";

// Communication
export const GET_LINKEDPORTALAGENT_COMPLETED = "GET_LINKEDPORTALAGENT_COMPLETED";
export const GET_CALLSESSION_COMPLETED = "GET_CALLSESSION_COMPLETED";
export const GET_WEBRTCONNECTION_COMPLETED = "GET_WEBRTCONNECTION_COMPLETED";

//PaginationlistTypes
export const GET_PAGINATIONTYPE_WAITINGLIST_COMPLETED = "GET_PAGINATIONTYPE_WAITINGLIST_COMPLETED";
export const GET_PAGINATIONTYPE_WEBCALL_COMPLETED = "GET_PAGINATIONTYPE_WEBCALL_COMPLETED";
export const GET_PAGINATIONTYPE_CALLOG_COMPLETED = "GET_PAGINATIONTYPE_CALLOG_COMPLETED";

// Dictionaries
export const GET_DICTIONNARY_ACCESSLEVELS = "GET_DICTIONNARY_ACCESSLEVELS";
export const GET_DICTIONNARY_CONTENTTYPES = "GET_DICTIONNARY_CONTENTTYPES";
export const GET_TRANSITIONS_COMPLETED = "GET_TRANSITIONS_COMPLETED";
export const GET_FONTS_COMPLETED = "GET_FONTS_COMPLETED";
export const GET_TAGS_COMPLETED = "GET_TAGS_COMPLETED";

// Contents
export const GET_PLAYLIST_COMPLETED = "GET_PLAYLIST_COMPLETED";
export const GET_CONTENTS_COMPLETED = "GET_CONTENTS_COMPLETED";
export const GET_VIDEMESSAGES_COMPLETED = "GET_VIDEMESSAGES_COMPLETED";
export const GET_STORAGE_COMPLETED = "GET_STORAGE_COMPLETED";
export const GET_CONTENTS_SECONDARY_COMPLETED = "GET_CONTENTS_SECONDARY_COMPLETED";
export const GET_COMPOSITIONS_COMPLETED = "GET_COMPOSITIONS_COMPLETED";
export const GET_COMPOSITIONS_SECONDARY_COMPLETED = "GET_COMPOSITIONS_SECONDARY_COMPLETED";
export const GET_PLAYLISTS_COMPLETED = "GET_PLAYLISTS_COMPLETED";
export const GET_PLAYLISTS_SECONDARY_COMPLETED = "GET_PLAYLISTS_SECONDARY_COMPLETED";
export const GET_STYLESLIST_COMPLETED = "GET_STYLES_COMPLETED";
export const GET_SCHEDULES_COMPLETED = "GET_SCHEDULES_COMPLETED";
export const CLEAR_PLAYLIST = "CLEAR_PLAYLIST";
export const UPDATE_PLAYLIST_TIMESTAMP = "UPDATE_PLAYLIST_TIMESTAMP";
export const GET_CONTENTS_STORAGESPACE = "GET_CONTENTS_STORAGESPACE";

// Monitoring
export const GET_DISPLAYSDISCONNECTEDCOUNT_COMPLETED = "GET_DISPLAYSDISCONNECTEDCOUNT_COMPLETED";
export const GET_DICTIONNARY_DISPLAYTYPES = "GET_DICTIONNARY_DISPLAYTYPES";
export const GET_DICTIONNARY_TIMEZONES = "GET_DICTIONNARY_TIMEZONES";
export const GET_DISPLAYS_COMPLETED = "GET_DISPLAYS_COMPLETED";
export const GET_PORTALAGENTS_COMPLETED = "GET_PORTALAGENTS_COMPLETED";
export const GET_PORTALAGENTS_SECONDARY_COMPLETED = "GET_PORTALAGENTS_SECONDARY_COMPLETED";
export const GET_DISPLAYS_SECONDARY_COMPLETED = "GET_DISPLAYS_SECONDARY_COMPLETED";
export const GET_DISPLAYGROUPS_COMPLETED = "GET_DISPLAYGROUPS_COMPLETED";
export const GET_CALLCENTERS_COMPLETED = "GET_CALLCENTERS_COMPLETED";
export const GET_CALLCENTERS_SECONDARY_COMPLETED = "GET_CALLCENTERS_SECONDARY_COMPLETED";
export const GET_FREECALLLINK_SECONDARY_COMPLETED = "GET_FREECALLLINK_SECONDARY_COMPLETED";
export const GET_DECISIONTREES_COMPLETED = "GET_DECISIONTREES_COMPLETED";
export const GET_DISPLAYGROUPS_SECONDARY_COMPLETED = "GET_DISPLAYGROUPS_SECONDARY_COMPLETED";
export const GET_DISPLAY_COMPLETED = "GET_DISPLAY_COMPLETED";
export const GET_LOG_UPDATED = "GET_LOG_UPDATED";
export const GET_DASHBOARDZONEID_UPDATED = "GET_DASHBOARDZONEID_UPDATED";
export const GET_CALLOGZONEID_UPDATED = "GET_CALLOGZONEID_UPDATED";
export const GET_FREECALLLINKS_COMPLETED = "GET_FREECALLLINKS_COMPLETED";
export const GET_RECALLLINKS_COMPLETED = "GET_RECALLLINKS_COMPLETED";
export const GET_FREECALLAPP_COMPLETED = "GET_FREECALLAPP_COMPLETED";

//Administration
export const GET_INVITATIONSCOUNT_COMPLETED = "GET_INVITATIONSCOUNT_COMPLETED";
export const GET_VIDEOMESSAGESNOTBEENSEENCOUNT_COMPLETED = "GET_VIDEOMESSAGESNOTBEENSEENCOUNT_COMPLETED";
export const GET_CONTENTGROUPS_COMPLETED = "GET_CONTENTGROUPS_COMPLETED";
export const GET_CONTENTGROUPS_SECONDARY_COMPLETED = "GET_CONTENTGROUPS_SECONDARY_COMPLETED";
export const GET_USERS_COMPLETED = "GET_USERS_COMPLETED";
export const GET_USERS_SECONDARY_COMPLETED = "GET_USERS_SECONDARY_COMPLETED";
export const GET_INVITATIONS_COMPLETED = "GET_INVITATIONS_COMPLETED";
export const GET_USERGROUPS_COMPLETED = "GET_USERGROUPS_COMPLETED";
export const GET_ZONES_COMPLETED = "GET_ZONES_COMPLETED";
export const GET_CALLCATEGORIES_COMPLETED = "GET_CALLCATEGORIES_COMPLETED";
export const GET_ZONES_SECONDARY_COMPLETED = "GET_ZONES_SECONDARY_COMPLETED";
export const GET_USERGROUPS_SECONDARY_COMPLETED = "GET_USERGROUPS_SECONDARY_COMPLETED";

// AlertDialog
export const OPEN_ALERTDIALOG = "OPEN_ALERTDIALOG";
export const CLOSE_ALERTDIALOG = "CLOSE_ALERTDIALOG";
export const CLEAR_DIALOG = "CLEAR_DIALOG";

// Deployments
export const GET_WAITINGDEPLOYMENTSCOUNT_COMPLETED = "GET_WAITINGDEPLOYMENTSCOUNT_COMPLETED";
export const GET_DEPLOYMENTSLIST_COMPLETED = "GET_DEPLOYMENTSLIST_COMPLETED";
export const CREATE_DEPLOYMENT = "CREATE_DEPLOYMENT";
export const CREATE_DEPLOYMENT_COMPLETED = "CREATE_DEPLOYMENT_COMPLETED";
export const CREATE_DEPLOYMENT_FAILED = "CREATE_DEPLOYMENT_FAILED";

// Styles
export const GET_STYLES_COMPLETED = "GET_STYLES_COMPLETED";
export const GET_STYLESLIST_SECONDARY_COMPLETED = "GET_STYLESLIST_SECONDARY_COMPLETED";
export const GET_STYLE_COMPLETED = "GET_STYLE_COMPLETED";
export const CLEAR_STYLE = "CLEAR_STYLE";

// SuperAdmin
export const GET_ERROR_REPORTS_COMPLETED = "GET_ERROR_REPORTS_COMPLETED";
export const GET_ERROR_REPORT_COMPLETED = "GET_ERROR_REPORT_COMPLETED";
export const CLEAR_ERROR_REPORT = "CLEAR_ERROR_REPORT";
export const GET_ORGANIZATIONS_COMPLETED = "GET_ORGANIZATIONS_COMPLETED";

// Upload manager
export const OPEN_UPLOAD_MANAGER = "OPEN_UPLOAD_MANAGER";
export const CLOSE_UPLOAD_MANAGER = "CLOSE_UPLOAD_MANAGER";
export const UPDATE_UPLOAD_PROGRESS = "UPDATE_UPLOAD_PROGRESS";
export const PUT_FILE_IN_PROGRESS = "PUT_FILE_IN_PROGRESS";
export const PUT_FILES_IN_QUEUE = "PUT_FILES_IN_QUEUE";
export const PUT_FILE_IN_DONE = "PUT_FILE_IN_DONE";

// Forms
export const GET_FORMS_COMPLETED = "GET_FORMS_COMPLETED";
export const GET_FORMS_SECONDARY_COMPLETED = "GET_FORMS_SECONDARY_COMPLETED";

